import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
  getDoc
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie"; 

export const Create_account_qry = async (data) => {
  const { company, serviceid, companyuid } = data || {};

  // 1. Validate inputs
  if (!company?.trim()) {
    return { success: false, error: "Missing company" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }

  try {
    const servicetablename = "companies";
    const tablename = "accounts";
    // ✅ Check if domain already exists for this user
    const domainQuery = query(
      collection(db, tablename),
      where("guid", "==", guid)
    );
    const snapshot = await getDocs(domainQuery);
    if (snapshot.empty) {
      // ✅ Save parent document 
      // const parentDocRef = doc(db, tablename, guid);
      // const savequery = {
      //   ...data,
      //   status: true,
      //   guid,
      //   account_type: "admin",
      //   description: "Administrator account",
      //   sessiontoken,
      //   date_time: new Date(),
      //   date_time_update: new Date(),
      // };
      // await setDoc(parentDocRef, savequery);
    }
    // ================= SERVICE ACCOUNT =================
    const serviceDocRef = doc(
      db,
      servicetablename,
      companyuid
    );
    await setDoc(
      serviceDocRef,
      {
        ...data,
        guid,
        companyuid,
        serviceid: serviceid || null,
        last_bill_date_time: new Date(),
        days:365,
        indexnumber: 1,
        sessiontoken,
        status: true,
        date_time: new Date(),
        date_time_update: new Date(),
      },
      { merge: true }
    );
    // ================= ADMIN AUTHORITY =================

    // const staff_accounts_Ref = doc(
    //   dbwhatsapp,
    //   tablename,
    //   guid,
    //   "accounts_authority",
    //   companyuid
    // );

    // await setDoc(
    //   staff_accounts_Ref,
    //   {
    //     accountguid: guid,
    //     administration_login: true,
    //     queue_verification:true,
    //     account_type: "admin",
    //     description: "Administrator account",
    //     companyuid,
    //     indexnumber: 1,
    //     sessiontoken,
    //     status: true,
    //     date_time: new Date(),
    //   },
    //   { merge: true }
    // );
    return { success: true };
  } catch (err) {
    console.error("❌ Error saving document:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
